module.exports = __webpack_public_path__ + "rupay-cb2e8719e5613f70ec1a.svg";